import React, { useState, useEffect } from "react";
import "./gallery.css";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/footer";
import Heading from "../heading/heading";

function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    async function fetchData() {
      await fetch("https://tranquil-lake-34438.herokuapp.com/activities")
        .then((foundItems) => {
          if (foundItems.ok) {
            return foundItems.json();
          }
        })
        .then((foundItems) => setItems(foundItems));
    }

    fetchData();
  }, [items]);

  return (
    <div>
      <Navbar />
      <Heading title="Gallery" />
      {items.length === 0 ? (
        <p className="empty">Gallery is currently Empty!</p>
      ) : (
        <div>
          <div className="galler main">
            {items.map((item) => (
              <div key={item._id}>
                <img src={item.imageUrl} alt="" />
              </div>
            ))}
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default Gallery;
